<template>
    <div>
        <div class="row">
            <div class="col-sm-6 col-md-6 col-lg-3" v-for="(item, idx) in dashboardItems" :key="idx">
                <div class="card">
                    <div class="card-header">
                        <h3>{{ item.title }}</h3>
                    </div>
                    <div class="card-body">
                        <p class="card-text">
                          <ul>
                            <li v-if="item.pending !== undefined"><router-link :to=item.link>{{ item.pending }} pendentes de Validação</router-link></li>
                            <li v-if="item.approved !== undefined">{{ item.approved }} aprovados</li>
                          </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'

miniToastr.init()

export default {
  name: 'dashboard',
  propData: {
    'pendingLinkParams': ''
  },
  props: [
    'pendingLinkParams'
  ],
  data () {
    return {
      dashboardItems: [],
      dashboardTitles: {
        'gestores': 'Gestores',
        'beneficiarios': 'Beneficiários',
        'tutores': 'Tutores',
        'voluntarios': 'Voluntários'
      }
    }
  },
  methods: {
    initDashboard () {
      Vue.http.get('api/dashboard').then(response => {
        let dataBody = response.body
        Object.entries(dataBody).forEach(([key, value]) => {
          this.dashboardItems.push({
            title: this.dashboardTitles[key.toString()] || key.toString(),
            pending: value.pendentes,
            approved: value.aprovados,
            link: this.pendingLinkParams[key] || {}
          })
        })
      })
    }
  },
  created () {
    this.initDashboard()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/dashboard.vue